<div *ngIf="options.backdrop !== false" class="modal-backdrop fade show" [ngClass]="options.backdropClass || ''"
    (click)="onBackdropClick()">
</div>

<div class="modal fade show" tabindex="-1">
    <div class="modal-dialog" [ngClass]="options.class || ''">
        <div class="modal-content">
            <ng-container #vc></ng-container>
        </div>
    </div>
</div>